import React, { useState } from "react";
import moment from "moment";
import { DatePicker, Space, Select, Input, notification } from "antd";
import { INTERNAL_STATUSES } from "../../constants/status";
import { SERVICE_PROVIDER_DETAILS } from "../../constants/serviceProviders";

const OrderFilters = ({ filters, onFiltersChange }) => {
  const [searchField, setSearchField] = useState("trackingNo");
  const today = moment();
  const oneWeekAgo = moment().subtract(7, "days");

  const searchBy = (
    <Select
      defaultValue="trackingNo"
      className="select-before"
      onChange={(value) => setSearchField(value)}
    >
      <Select.Option value="trackingNo">Tracking No</Select.Option>
      <Select.Option value="altConsignNo">Shipment ID</Select.Option>
      <Select.Option value="name">Receiver</Select.Option>
      <Select.Option value="orderId">Order Id</Select.Option>
    </Select>
  );

  return (
    <Space size="large" wrap>
      {filters.sortBy === "createdDate" && (
        <div>
          Order At :{` `}
          <DatePicker.RangePicker
            allowClear={false}
            allowEmpty={false}
            value={[filters.startDate, filters.endDate]}
            onChange={(dates) => {
              if (dates && dates[1].diff(dates[0], "days") > 90) {
                notification.error({
                  message: "Date Range cannot be more than 90 days.",
                  placement: "bottomRight",
                });
                return false;
              }

              dates
                ? onFiltersChange({
                  ...filters,
                  startDate: dates[0],
                  endDate: dates[1],
                  paymentStartDate: undefined,
                  paymentEndDate: undefined,
                })
                : onFiltersChange({
                  ...filters,
                  startDate: undefined,
                  endDate: undefined,
                });
            }}
          />
        </div>
      )}

      {filters.sortBy === "paymentDate" && (
        <div>
          Checkout At :{` `}
          <DatePicker.RangePicker
            allowClear={false}
            allowEmpty={false}
            value={[filters.paymentStartDate, filters.paymentEndDate]}
            onChange={(dates) => {
              if (dates && dates[1].diff(dates[0], "days") > 90) {
                notification.error({
                  message: "Date Range cannot be more than 90 days.",
                  placement: "bottomRight",
                });
                return false;
              }

              dates
                ? onFiltersChange({
                  ...filters,
                  paymentStartDate: dates[0],
                  paymentEndDate: dates[1],
                  startDate: undefined,
                  endDate: undefined,
                })
                : onFiltersChange({
                  ...filters,
                  paymentStartDate: undefined,
                  paymentEndDate: undefined,
                });
            }}
          />
        </div>
      )}

      {filters.sortBy === "pickedUpDate" && (
        <div>
          Pickup At :{` `}
          <DatePicker.RangePicker
            allowClear={false}
            allowEmpty={false}
            value={[filters.pickedUpStartDate, filters.pickedUpEndDate]}
            onChange={(dates) => {
              if (dates && dates[1].diff(dates[0], "days") > 90) {
                notification.error({
                  message: "Date Range cannot be more than 90 days.",
                  placement: "bottomRight",
                });
                return false;
              }
              dates
                ? onFiltersChange({
                    ...filters,
                    pickedUpStartDate: dates[0],
                    pickedUpEndDate: dates[1],
                    startDate: undefined,
                    endDate: undefined,
                    paymentStartDate: undefined,
                    paymentEndDate: undefined,
                  })
                : onFiltersChange({
                    ...filters,
                    pickedUpStartDate: undefined,
                    pickedUpEndDate: undefined,
                  });
            }}
          />
        </div>
      )}

      <div>
        Sort By :{` `}
        <Select
          placeholder="Sort By"
          style={{ width: 200 }}
          allowClear
          defaultValue="paymentDate"
          onChange={(value) =>
            onFiltersChange({
              ...filters,
              sortBy: value,
              startDate: value === "paymentDate" || value === "pickedUpDate" ? undefined : filters.startDate || oneWeekAgo,
              endDate: value === "paymentDate" || value === "pickedUpDate" ? undefined : filters.endDate || today,
              paymentStartDate:
                value === "createdDate" || value === "pickedUpDate" ? undefined : filters.paymentStartDate || oneWeekAgo,
              paymentEndDate: value === "createdDate" || value === "pickedUpDate" ? undefined : filters.paymentEndDate || today,
              pickedUpStartDate: value === "pickedUpDate" ? (filters.pickedUpStartDate || oneWeekAgo) : undefined,
              pickedUpEndDate: value === "pickedUpDate" ? (filters.pickedUpEndDate || today) : undefined,
            })
          }
        >
          <Select.Option value="paymentDate">Payment Date</Select.Option>
          <Select.Option value="createdDate">Created Date</Select.Option>
          <Select.Option value="pickedUpDate">Pickup Date</Select.Option>
        </Select>
      </div>

      <div>
        Channel :{` `}
        <Select
          placeholder="ALL"
          style={{ width: 200 }}
          allowClear
          onChange={(value) => onFiltersChange({ ...filters, channel: value })}
        >
          <Select.Option value="dashboard">Dashboard</Select.Option>
          <Select.Option value="dashboard-bulk">Dashboard (Bulk)</Select.Option>
          <Select.Option value="external">External</Select.Option>
          <Select.Option value="external-bulk">External (Bulk)</Select.Option>
          <Select.Option value="shopify">Shopify</Select.Option>
          <Select.Option value="shopify-new">Shopify (New)</Select.Option>
          <Select.Option value="woocommerce">WooCommerce</Select.Option>
          <Select.Option value="order-form">Order Form</Select.Option>
        </Select>
      </div>

      <div>
        Search :{` `}
        <Input.Search
          addonBefore={searchBy}
          placeholder="Search"
          onSearch={(term) =>
            onFiltersChange({ ...filters, search: term, searchField })
          }
        />
      </div>

      <div>
        Courier:{` `}
        <Select
          placeholder="ALL"
          style={{ width: 200 }}
          allowClear
          onChange={(value) =>
            onFiltersChange({ ...filters, serviceProvider: value })
          }
        >
          {SERVICE_PROVIDER_DETAILS.map(({ key, name }) => (
            <Select.Option key={key} value={key}>
              {name}
            </Select.Option>
          ))}
        </Select>
      </div>

      <div>
        Internal Status :{" "}
        <Select
          mode="multiple"
          placeholder="ALL"
          style={{ width: 200 }}
          allowClear
          onChange={(value) =>
            onFiltersChange({ ...filters, internalStatus: value })
          }
        >
          {INTERNAL_STATUSES.map((status) => (
            <Select.Option key={status} value={status}>
              {status}
            </Select.Option>
          ))}
        </Select>
      </div>
    </Space>
  );
};

export default OrderFilters;
